export default __webpack_public_path__ + "static/media/logo.724bcc9e.jpg";